import type { RouteRecordRaw } from 'vue-router';

import {
  CARD_DETAILS_ROUTE_NAME,
  CARD_RESULT_ROUTE_NAME,
  CARDS_ROUTE_NAME,
  ORDER_CARD_ROUTE_NAME,
  ORDER_PHYSICAL_CARD_ROUTE_NAME,
} from './internal/cards.constants';

export const cardsRoutes = [
  {
    path: 'cards',
    name: CARDS_ROUTE_NAME,
    component: () => import('./views/CardsOverviewPage.vue'),
    meta: { title: 'Cards' },
  },
  {
    path: 'cards/order',
    name: ORDER_CARD_ROUTE_NAME,
    component: () => import('./views/OrderCardPage.vue'),
    meta: { title: 'Order Card' },
  },
  {
    path: 'cards/result',
    name: CARD_RESULT_ROUTE_NAME,
    component: () => import('./views/CardResultPage.vue'),
    meta: { title: 'Cards' },
  },
  {
    path: 'cards/:cardId/order-physical',
    name: ORDER_PHYSICAL_CARD_ROUTE_NAME,
    component: () => import('./views/OrderPhysicalCardPage.vue'),
    meta: { title: 'Order Physical Card' },
  },
  {
    path: 'cards/:cardId',
    name: CARD_DETAILS_ROUTE_NAME,
    component: () => import('./views/CardDetailsPage.vue'),
    meta: { title: 'Card details' },
  },
] as const satisfies readonly RouteRecordRaw[];
